import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderNumberColumnHeader: {
    id: 'xaZFwf',
    defaultMessage: 'Order ID',
    description: 'Header for order number column in transfer orders grid',
  },
  originWarehouseColumnHeader: {
    id: '+uXy71',
    defaultMessage: 'Origin Warehouse',
    description: 'Header for origin warehouse column in transfer orders grid',
  },
  destinationWarehouseColumnHeader: {
    id: '+pZte/',
    defaultMessage: 'Destination Warehouse',
    description: 'Header for destination warehouse column in transfer orders grid',
  },
  statusColumnHeader: {
    id: '1n2sfM',
    defaultMessage: 'Status',
    description: 'Header for status column in transfer orders grid',
  },
  orderDateColumnHeader: {
    id: '0fK6uA',
    defaultMessage: 'Order Date',
    description: 'Header for order date column in transfer orders grid',
  },
  expectedDeliveryDateColumnHeader: {
    id: 'kCFJmZ',
    defaultMessage: 'Expected Delivery Date',
    description: 'Header for expected delivery date column in transfer orders grid',
  },
  receiveStockHeader: {
    id: 'mdvcTq',
    defaultMessage: 'Receive Stock',
    description: 'Header for receive stock column in transfer orders grid',
  },
  receiveStockButton: {
    id: '4TmOl4',
    defaultMessage: 'Receive',
    description: 'Button text for receive stock action in transfer orders grid',
  },
  gridPlaceholderTitle: {
    id: '9gYtEK',
    defaultMessage: 'You have no <b>Transfer Orders</b> to view',
    description: 'Transfer Orders Placeholder Title',
  },
  gridPlaceholderDescription: {
    id: 'KcI/xn',
    defaultMessage: 'No Transfer Orders data to view at the moment',
    description: 'Transfer Orders Placeholder Description',
  },
  loadDraftErrorTitle: {
    id: 'yFpOLF',
    defaultMessage: 'Failed to load draft',
    description: 'Error notification title when loading draft transfer order fails',
  },
  loadDraftErrorContent: {
    id: 'TvKON7',
    defaultMessage: 'Could not load the draft transfer order. Please try again.',
    description: 'Error notification content when loading draft transfer order fails',
  },
});
